/**
 * TEMPORARY — Duplicate Accounts (merge) is gated in one place.
 *
 * Set the constant below to true (lowercase — JavaScript, not Python True) when you want the UI live.
 * Keep it `false` for production merges so nobody can open the tool until you are ready.
 * When the feature is fully released, delete this file and remove all imports/usages.
 */
const DUPLICATE_ACCOUNTS_MERGE_UI_ON = true;

/** Client-facing copy when merge UI is gated off (tooltips, menu caption, route placeholder). */
export const DUPLICATE_ACCOUNTS_MERGE_LOCKED_USER_MESSAGE =
  "This feature is in testing and development. It is not available for use yet and will be released when it is ready.";

export function isDuplicateAccountsMergeUiEnabled() {
  return DUPLICATE_ACCOUNTS_MERGE_UI_ON;
}
